'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Vivus = require("vivus");
var Scroll;
(function (Scroll) {
    var Common = /** @class */ (function () {
        function Common() {
            // PCより大きいサイズ
            this.OVERPCWIDTH = 1200;
            var self = this;
            $(window).on('load', function () {
                self.aboutPosition = $('.paramAbout').offset().top;
                self.projectPosition = $('.paramProject').offset().top;
                self.galleryPosition = $('.paramGallery').offset().top - 5;
            });
            $(window).on('scroll', function () {
                var scroll = $(this).scrollTop();
                if (self.isSpWidth()) {
                    var section = void 0;
                    if (self.aboutPosition <= scroll) {
                        section = 'about';
                    }
                    if (self.projectPosition <= scroll) {
                        section = 'project';
                    }
                    if (self.galleryPosition <= scroll) {
                        section = 'gallery';
                    }
                    switch (section) {
                        case 'about':
                            $('.bulletNaviAbout').attr('data-active', 'true');
                            $('.bulletNaviProject').attr('data-active', 'false');
                            $('.bulletNaviGallery').attr('data-active', 'false');
                            break;
                        case 'project':
                            $('.bulletNaviAbout').attr('data-active', 'false');
                            $('.bulletNaviProject').attr('data-active', 'true');
                            $('.bulletNaviGallery').attr('data-active', 'false');
                            break;
                        case 'gallery':
                            $('.bulletNaviAbout').attr('data-active', 'false');
                            $('.bulletNaviProject').attr('data-active', 'false');
                            $('.bulletNaviGallery').attr('data-active', 'true');
                            break;
                        default:
                            $('.bulletNaviAbout').attr('data-active', 'false');
                            $('.bulletNaviProject').attr('data-active', 'false');
                            $('.bulletNaviGallery').attr('data-active', 'false');
                            break;
                    }
                }
            });
        }
        Common.prototype.isSpWidth = function () {
            var flag = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth < this.OVERPCWIDTH) {
                flag = true;
            }
            return flag;
        };
        return Common;
    }());
    Scroll.Common = Common;
    var About = /** @class */ (function () {
        function About() {
            // PCより大きいサイズ
            this.OVERPCWIDTH = 1200;
            var self = this;
            var position = $('.paramAbout').offset().top;
            var browserHeight = $(window).outerHeight();
            var overSteeringPC = browserHeight * 0.75;
            var overSteeringSP = browserHeight / 2;
            var options = {
                duration: 100,
                start: 'manual',
                type: 'oneByOne',
                forceRender: false
            };
            var optionsSP = {
                duration: 100,
                start: 'manual',
                type: 'oneByOne',
                forceRender: false
            };
            var aboutLine = new Vivus('bulletAboutFirstAnimation', options, function () { });
            var aboutLineSP = new Vivus('bulletAboutLineSP', optionsSP, function () { });
            aboutLine.stop();
            aboutLineSP.stop();
            var wait = function (milliseconds) { return new Promise(function (resolve) { return setTimeout(resolve, milliseconds); }); };
            $(window).on('scroll', function () {
                var scroll = $(this).scrollTop();
                if (self.isSpWidth()) {
                    if (position - overSteeringSP <= scroll) {
                        aboutLineSP.play();
                    }
                    // 共通なので、別関数に分けたほうが良い
                    self.changeDataActiveSP(scroll);
                }
                else {
                    if (position - overSteeringPC <= scroll) {
                        Promise.resolve()
                            .then(function () { return aboutLine.play(); })
                            .then(function () { return wait(1500); })
                            .then(function () { return self.changeDataActive('bulletAboutTitle'); })
                            .then(function () { return wait(300); })
                            .then(function () { return self.changeDataActive('bulletAboutSub'); })
                            .then(function () { return wait(600); })
                            .then(function () { return self.changeDataActive('bulletAboutIntro'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletAboutBasis'); })
                            .then(function () { return wait(600); })
                            .then(function () { return self.changeDataActive('bulletAboutItem01'); })
                            .then(function () { return wait(400); })
                            .then(function () { return self.changeDataActive('bulletAboutItem02'); })
                            .then(function () { return wait(400); })
                            .then(function () { return self.changeDataActive('bulletAboutItem03'); });
                    }
                }
                self.moveParallaxAnimation(scroll);
            });
        }
        About.prototype.moveParallaxAnimation = function (scroll) {
            var moveParameter01 = Math.round(scroll * 0.4);
            $('.bulletParallax01').css('transform', 'translate3d(0px, ' + (-moveParameter01) + 'px, 0px)');
            var moveParameter02 = Math.round(scroll * 0.2);
            $('.bulletParallax02').css('transform', 'translate3d(0px, ' + (-moveParameter02) + 'px, 0px)');
        };
        About.prototype.changeDataActive = function (name) {
            $('.' + name).attr('data-active', 'true');
        };
        About.prototype.isSpWidth = function () {
            var flag = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth < this.OVERPCWIDTH) {
                flag = true;
            }
            return flag;
        };
        About.prototype.changeDataActiveSP = function (scroll) {
            $('.bulletScrollShow').each(function () {
                var elementPosition = $(this).offset().top;
                var browserHeight = $(window).outerHeight();
                var overSteering = browserHeight / 2;
                if (elementPosition - overSteering <= scroll) {
                    $(this).attr('data-active', 'true');
                }
            });
        };
        return About;
    }());
    Scroll.About = About;
    var Project = /** @class */ (function () {
        function Project() {
            // PCより大きいサイズ
            this.OVERPCWIDTH = 1200;
            var self = this;
            var position = $('.paramProject').offset().top;
            var options = {
                duration: 75,
                start: 'manual',
                type: 'oneByOne',
                forceRender: false
            };
            var optionsSP = {
                duration: 10,
                start: 'manual',
                type: 'oneByOne',
                forceRender: false
            };
            var line = new Vivus('bulletProjectLine', options, function () { });
            var line01 = new Vivus('bulletProjectLine01', optionsSP, function () { });
            var line02 = new Vivus('bulletProjectLine02', optionsSP, function () { });
            line.stop();
            line01.stop();
            line02.stop();
            var wait = function (milliseconds) { return new Promise(function (resolve) { return setTimeout(resolve, milliseconds); }); };
            var browserHeight = $(window).outerHeight();
            var overSteeringPC = browserHeight * 0.75;
            var overSteeringSP = browserHeight / 2;
            $(window).on('scroll', function () {
                var scroll = $(this).scrollTop();
                if (self.isSpWidth()) {
                    if (position - overSteeringSP <= scroll) {
                        Promise.resolve()
                            .then(function () { return line01.play(); })
                            .then(function () { return wait(1000); })
                            .then(function () { return line02.play(); });
                    }
                }
                else {
                    if (position - overSteeringPC <= scroll) {
                        Promise.resolve()
                            .then(function () { return line.play(); })
                            .then(function () { return wait(1500); })
                            .then(function () { return self.changeDataActive('bulletProjectTitle'); })
                            .then(function () { return wait(600); })
                            .then(function () { return self.changeDataActive('bulletProjectIntro'); })
                            .then(function () { return wait(600); })
                            .then(function () { return self.changeDataActive('bulletProjectMovie'); })
                            .then(function () { return self.changeDataActive('bulletProjectMaking'); })
                            .then(function () { return wait(900); })
                            .then(function () { return self.changeDataActive('bulletProjectSubTitle'); })
                            .then(function () { return wait(500); })
                            .then(function () { return self.changeDataActive('bulletProjectPoster01'); })
                            .then(function () { return wait(500); })
                            .then(function () { return self.changeDataActive('bulletProjectPoster02'); })
                            .then(function () { return wait(500); })
                            .then(function () { return self.changeDataActive('bulletProjectPoster03'); })
                            .then(function () { return self.changeDataActive('bulletProjectPoster04'); })
                            .then(function () { return self.changeDataActive('bulletProjectHint'); });
                    }
                }
            });
        }
        Project.prototype.changeDataActive = function (name) {
            $('.' + name).attr('data-active', 'true');
        };
        Project.prototype.isSpWidth = function () {
            var flag = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth < this.OVERPCWIDTH) {
                flag = true;
            }
            return flag;
        };
        return Project;
    }());
    Scroll.Project = Project;
    var Ooh = /** @class */ (function () {
        function Ooh() {
            // PCより大きいサイズ
            this.OVERPCWIDTH = 1200;
            var self = this;
            var position;
            var wait = function (milliseconds) { return new Promise(function (resolve) { return setTimeout(resolve, milliseconds); }); };
            var browserHeight = $(window).outerHeight();
            var overSteeringPC = browserHeight * 0.75;
            var overSteeringSP = browserHeight / 2;
            $(window).on('load', function () {
                position = $('.paramOoh').offset().top;
            });
            $(window).on('scroll', function () {
                var scroll = $(this).scrollTop();
                if (self.isSpWidth()) {
                    if (position - overSteeringSP <= scroll) {
                        Promise.resolve()
                            .then(function () { return self.changeDataActive('bulletOohTitle'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletOohEnglish'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletOohJapanese'); });
                    }
                }
                else {
                    if (position - overSteeringPC <= scroll) {
                        Promise.resolve()
                            .then(function () { return self.changeDataActive('bulletOohTitle'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletOohEnglish'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletOohJapanese'); });
                    }
                }
            });
        }
        Ooh.prototype.changeDataActive = function (name) {
            $('.' + name).attr('data-active', 'true');
        };
        Ooh.prototype.isSpWidth = function () {
            var flag = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth < this.OVERPCWIDTH) {
                flag = true;
            }
            return flag;
        };
        return Ooh;
    }());
    Scroll.Ooh = Ooh;
    var OohJr = /** @class */ (function () {
        function OohJr() {
            // PCより大きいサイズ
            this.OVERPCWIDTH = 1200;
            var self = this;
            var position;
            var wait = function (milliseconds) { return new Promise(function (resolve) { return setTimeout(resolve, milliseconds); }); };
            var browserHeight = $(window).outerHeight();
            var overSteeringPC = browserHeight * 0.75;
            var overSteeringSP = browserHeight / 2;
            $(window).on('load', function () {
                position = $('.paramOohJr').offset().top;
            });
            $(window).on('scroll', function () {
                var scroll = $(this).scrollTop();
                if (self.isSpWidth()) {
                    if (position - overSteeringSP <= scroll) {
                        Promise.resolve()
                            .then(function () { return self.changeDataActive('bulletOohJrEnglish'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletOohJrJapanese'); });
                    }
                }
                else {
                    if (position - overSteeringPC <= scroll) {
                        Promise.resolve()
                            .then(function () { return self.changeDataActive('bulletOohJrEnglish'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletOohJrJapanese'); });
                    }
                }
            });
        }
        OohJr.prototype.changeDataActive = function (name) {
            $('.' + name).attr('data-active', 'true');
        };
        OohJr.prototype.isSpWidth = function () {
            var flag = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth < this.OVERPCWIDTH) {
                flag = true;
            }
            return flag;
        };
        return OohJr;
    }());
    Scroll.OohJr = OohJr;
    var Cm = /** @class */ (function () {
        function Cm() {
            // PCより大きいサイズ
            this.OVERPCWIDTH = 1200;
            var self = this;
            var position;
            var wait = function (milliseconds) { return new Promise(function (resolve) { return setTimeout(resolve, milliseconds); }); };
            var browserHeight = $(window).outerHeight();
            var overSteeringPC = browserHeight * 0.75;
            var overSteeringSP = browserHeight / 2;
            $(window).on('load', function () {
                position = $('.paramCm').offset().top;
            });
            $(window).on('scroll', function () {
                var scroll = $(this).scrollTop();
                if (self.isSpWidth()) {
                    if (position - overSteeringSP <= scroll) {
                        Promise.resolve()
                            .then(function () { return self.changeDataActive('bulletCmTitle'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletTvCm'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletWebCm'); });
                    }
                }
                else {
                    if (position - overSteeringPC <= scroll) {
                        Promise.resolve()
                            .then(function () { return self.changeDataActive('bulletCmTitle'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletTvCm'); })
                            .then(function () { return wait(1000); })
                            .then(function () { return self.changeDataActive('bulletWebCm'); });
                    }
                }
            });
        }
        Cm.prototype.changeDataActive = function (name) {
            $('.' + name).attr('data-active', 'true');
        };
        Cm.prototype.isSpWidth = function () {
            var flag = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth < this.OVERPCWIDTH) {
                flag = true;
            }
            return flag;
        };
        return Cm;
    }());
    Scroll.Cm = Cm;
    var Gallery = /** @class */ (function () {
        function Gallery() {
            // PCより大きいサイズ
            this.OVERPCWIDTH = 1200;
            var self = this;
            var position;
            var browserHeight = $(window).outerHeight();
            var overSteeringPC = browserHeight * 0.75;
            var overSteeringSP = browserHeight / 2;
            $(window).on('load', function () {
                position = $('.paramGallery').offset().top;
            });
            $(window).on('scroll', function () {
                var scroll = $(this).scrollTop();
                if (self.isSpWidth()) {
                    if (position - overSteeringSP <= scroll) {
                        self.changeDataActive('bulletGalleryTitle');
                    }
                }
                else {
                    if (position - overSteeringPC <= scroll) {
                        self.changeDataActive('bulletGalleryTitle');
                    }
                }
            });
        }
        Gallery.prototype.changeDataActive = function (name) {
            $('.' + name).attr('data-active', 'true');
        };
        Gallery.prototype.isSpWidth = function () {
            var flag = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth < this.OVERPCWIDTH) {
                flag = true;
            }
            return flag;
        };
        return Gallery;
    }());
    Scroll.Gallery = Gallery;
})(Scroll || (Scroll = {}));
exports.default = Scroll;
